import { render } from "./inputTel.vue?vue&type=template&id=28c9ed3d&scoped=true&ts=true"
import script from "./inputTel.vue?vue&type=script&lang=ts"
export * from "./inputTel.vue?vue&type=script&lang=ts"

import "./inputTel.vue?vue&type=style&index=0&id=28c9ed3d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c9ed3d"]])

export default __exports__